import useDocumentTitle from '../hooks/useDocument';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import ValuesDetail from '../components/valuesdetail';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function ValuesView() {
  useDocumentTitle('Our values-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-5'} title={'Our Values'} link={'Values'} />
      <ValuesDetail />
      <div className="call-to-action-area call-to-action-5 bg-image bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="white-color">Care</h2>
                <p className="white-color">
                  The focus of our business is care. Care justifies everything
                  we do. Providing excellent care to our clients and their
                  families is always our priority.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="compassion">Compassion</h2>
                <p className="">
                  Our client relationships are based on trust, empathy, respect
                  and dignity, qualities we believe are central to how people
                  perceive their care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="white-color">Competence</h2>
                <p className="white-color">
                  We make sure that our care staff do not only understand an
                  individual 's personal, health and social needs. They have the
                  confidence, clinical and technical knowledge as well as
                  expertise to deliver excellent care.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="compassion">Communication</h2>
                <p className="">
                  Communication is key to thriving relationships and effective
                  team work. What we say and do are as important as listening.
                  These are essential for “no decision about me without me”.
                  Communication is central in a conducive workplace which is
                  benefitial to clients and staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="white-color">Courage</h2>
                <p className="white-color">
                  Courage empowers us to do the correct thing for our clients,
                  to voice our concerns, to have the personal strength and
                  vision to cause positive change and to accept new ways of
                  working.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left ">
                <h2 className="compassion">Commitment</h2>
                <p className="">
                  Our permanent commitment to our clients makes them feel
                  genuinely cared for. The benefits we provide to our care
                  workers support our desire for a committed workforce that
                  touch our clients is at the heart of all we do.
                </p>
                <p className="mt-5">
                  Each of these values and behaviors weigh the same. None of the
                  6 Cs is more important than the other. Each one focuses on
                  putting the person being cared for at the center of the care
                  they are given.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-user-nurse"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="We deliver personal and complex care in your home."
        btn1="Meet our team"
        btn2=" Our care service"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default ValuesView;
